/**
 * Мок API в памяти: отвечает по контрактам на все эндпоинты (TypeScript требует обработчик на каждый — `ApiHandlers`).
 * Включается `?mock=1` в адресе или `VITE_API_MOCK=1`; нужен, пока сервер — заглушка, и для разработки окон и вкладок.
 */
import type { ApiHandlers, ApiResponse, EndpointName } from "@newfungame/contracts";
import { ApiError, endpoints, samplePlayerState } from "@newfungame/contracts";
import type { ApiTransport } from "../transport";
import { authHandlers } from "./auth";
import { betaHandlers } from "./beta";
import { economyHandlers } from "./economy";
import { leagueHandlers } from "./league";
import { paymentsHandlers } from "./payments";
import { playerHandlers } from "./player";
import { shareHandlers } from "./share";
import { wavesHandlers } from "./waves";
import type { FakeDb } from "./db";

export function createFakeTransport(now: () => number = Date.now): ApiTransport {
  const db: FakeDb = {
    state: samplePlayerState(now()),
    fresh: () => (db.state = { ...db.state, serverTime: now() }),
  };
  const handlers: ApiHandlers = {
    ...authHandlers(db),
    ...betaHandlers(db),
    ...economyHandlers(db),
    ...leagueHandlers(db),
    ...paymentsHandlers(db),
    ...playerHandlers(db),
    ...shareHandlers(db),
    ...wavesHandlers(db),
  };

  return {
    async call(name, req) {
      const ep = endpoints[name];
      const parsed = ep.request.safeParse(req);
      if (!parsed.success) throw new ApiError("bad_request", parsed.error.message);
      const handler = handlers[name] as (r: unknown, ctx: void) => Promise<ApiResponse<EndpointName>>;
      return ep.response.parse(await handler(parsed.data, undefined)) as ApiResponse<typeof name>;
    },
  };
}
